import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    .ant-select-dropdown.customer-select-dropdown {
        width: 40% !important;        
    }
    .ant-select-item-option-content {
        padding: 0.25rem;
    }

    // Customizando os selects de forma de pagamento da tabela do shoppingCart
    .ant-select-dropdown.payment-term-dropdown {
        width: 20rem !important;
    }

    .fabrication-project-select-dropdown {
        width: 20rem !important;
    }

    // Customizando os selects de destinação da tabela do shoppingCart
    .ant-select-dropdown.destination-dropdown {
        width: 9rem !important;
    }

    // Feito para não quebrar o texto do status com a bola colorida
    .ant-select-dropdown.orders-status-select-dropdown {
        width: 11rem !important;
    }

    // dropdown do select do componente CountryPhoneInput
    .ant-select-dropdown.country-select {
        width: 11rem !important;
    }

    // dropdown do select de Tipos de arame
    .ant-select-dropdown.wire-types-select {
        width: 12rem !important;
    }

    // dropdown select de contratos corte e dobra
    .ant-select-dropdown.contracts-select {
        width: 20rem !important;
    }

    // Feito para não quebrar o texto no select de TIPO DE PRODUTO
    .ant-select-dropdown.product-type-select-dropdown {
        width: 15rem !important;
    }

    // 
    .ant-select-dropdown.project-select {
        width: 22rem !important;
    }

    // Mudando cor do ícone do ant select
    .ant-select > .ant-select-arrow {
        color: ${({ theme }) => theme.colors.grayDark2};
    }

    // Feito isso para em telas menores, quando abrir o rangePicker, uma data ficar em baixo da outra
    .ant-picker-panels {
        @media(max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            display: flex;
            flex-direction: column;
        }
    }
    .ant-picker-range-wrapper.ant-picker-date-range-wrapper {
        min-width: unset !important;
    }

    .ant-table-thead > tr > th.ant-table-cell {
        font-size: 0.75rem;
        line-height: 1.3rem;
        font-weight: bold;
        color: ${({ theme }) => theme.colors.grayDark};
    }

    // Feito para deixar os botões para trocar de página centralizado, quando em telas menores
    .ant-table-pagination.ant-pagination {
        @media(max-width: ${({ theme }) => theme.breakpoints.tablet}) {
            justify-content: center;
            margin: 1rem;
        }
    }

    // Footer da tabela contendo o resumo do que está sendo mostrado
    .ant-table-footer {
        text-align: center;
        
        @media(min-width: ${({ theme }) => theme.breakpoints.laptop}) {
            position: absolute;
            background: none;
            text-align: left;
            margin-top: 0.7rem;
            width: 50%;
        }
    }

    // Feito isso para não esconder o select de itens por página, quando em telas menores
    .ant-pagination-options {
        display: block !important;
    }


    // Feito para a barra de scroll dos campos de Select do Antd ficar sempre visível
    .rc-virtual-list-scrollbar {
        display: block !important;
    }

    .by-day-table .ant-table-content {
        &::-webkit-scrollbar {
            height: 0.5rem !important;
        }

        &::-webkit-scrollbar-thumb {
            width: unset;
        }
    }

    // remover margin-bottom padrão de Form.Item 
    .ant-form-item {
        margin-bottom: unset;
    }

    // Customizando tooltips de erro dos inputs do carrinho
    .shop-cart-input-tooltip, .fabrication-order-input-tooltip {
        & > div.ant-tooltip-content {
            & > div.ant-tooltip-inner {
                border: 1px solid ${({ theme }) => theme.colors.red2};
                background-color: ${({ theme }) =>
                  theme.colors.redLight} !important;
                font-size: 0.875rem;
                color: ${({ theme }) => theme.colors.black};
                font-weight: 600;
            }
        }

        &.ant-tooltip-placement-top > div.ant-tooltip-content {
            & > div.ant-tooltip-arrow {
                overflow: unset;
                & > span.ant-tooltip-arrow-content {
                    background-color: ${({ theme }) =>
                      theme.colors.redLight} !important;
                    border-right: 1px solid ${({ theme }) => theme.colors.red2};
                    border-bottom: 1px solid ${({ theme }) =>
                      theme.colors.red2};
                }
            }
        }

        &.ant-tooltip-placement-bottom > div.ant-tooltip-content {
            & > div.ant-tooltip-arrow {
                overflow: unset;
                & > span.ant-tooltip-arrow-content {
                    background-color: ${({ theme }) =>
                      theme.colors.redLight} !important;
                    border-left: 1px solid ${({ theme }) => theme.colors.red2};
                    border-top: 1px solid ${({ theme }) => theme.colors.red2};
                }
            }
        }   
    }

    // tracking-long-steel-tooltip
    .tracking-long-steel-tooltip > div.ant-tooltip-content, .repeated-order-number > div.ant-tooltip-content {
        & > div.ant-tooltip-inner {
            font-size: 0.75rem;
            font-weight: 600;
            background-color: ${({ theme }) =>
              theme.colors.neutralsGray} !important;
        }
    }

`;
